module.exports = __webpack_public_path__ + "stylesheets/section-feedback_4484ddc6138f0bbe74050e2749218a32.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-feedback.less
// module id = QAC1
// module chunks = 151